import Close16 from '@carbon/icons-react/es/close/16';
import React, { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'components/atoms/button';
import { ProductiveHeading06 } from 'components/styles';

const Header = styled.div`
  height: var(--layout-06);
  background: var(--primary-color);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
  padding: var(--layout-01);
  ${ProductiveHeading06};
  color: white;
  margin-bottom: var(--layout-01);
`;

const CloseButton = styled(Button).attrs({
  type: 'text',
  shape: 'circle',
  icon: <Close16 fill="white" />,
})`
  position: absolute;
  top: var(--spacing-02);
  right: var(--spacing-02);
`;

const Panel = styled.aside<{ width?: number; visible?: boolean }>`
  --action-panel-header-background: var(--coolest-gray-10);
  --action-panel-shadow: var(--shadow-04);

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  ${({ width = 256, visible }) => css`
    min-width: ${visible ? width : 0}px;
    max-width: ${visible ? width : 0}px;
    width: ${visible ? width : 0}px;
    flex: 0 0 ${visible ? width : 0}px;
  `};
  box-shadow: var(--action-panel-shadow);
  transition: all var(--animation-duration-fast);
`;

type Props = ComponentPropsWithoutRef<typeof Panel> & {
  title?: ReactNode;
  onClose?: () => void;
};

/* eslint-disable react/jsx-props-no-spreading */
export const ActionPanel: FC<Props> = ({
  title,
  onClose,
  children,
  visible,
  ...rest
}) => (
  <Panel {...rest} visible={visible} data-cy="action-panel">
    {visible ? (
      <>
        <CloseButton onClick={onClose} />
        <Header data-cy="action.panel.header">{title}</Header>
        {children}
      </>
    ) : null}
  </Panel>
);
/* eslint-enable react/jsx-props-no-spreading */
